export default __webpack_public_path__ + "static/media/talkingMan.9bf10b58.webm";